import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Pencil, Upload } from "lucide-react";
import { UpdateMethod } from "./types";

type UpdateMethodSelectorProps = {
  onSelect: (method: UpdateMethod) => void;
  onCancel: () => void;
};

export const UpdateMethodSelector = ({ onSelect, onCancel }: UpdateMethodSelectorProps) => (
  <div className="space-y-4">
    <div className="grid grid-cols-2 gap-4">
      <Card
        className="cursor-pointer hover:border-primary transition-colors"
        onClick={() => onSelect("upload")}
      >
        <CardContent className="flex flex-col items-center justify-center gap-3 py-8">
          <Upload className="h-8 w-8 text-muted-foreground" />
          <div className="text-center space-y-2">
            <p className="font-medium">Upload File</p>
            <p className="text-sm text-muted-foreground">
              Upload a spec file to create a new version
            </p>
          </div>
        </CardContent>
      </Card>
      <Card
        className="cursor-pointer hover:border-primary transition-colors"
        onClick={() => onSelect("manual")}
      >
        <CardContent className="flex flex-col items-center justify-center gap-3 py-8 pointer-events-none">
          <Pencil className="h-8 w-8 text-muted-foreground" />
          <div className="text-center space-y-2">
            <p className="font-medium">Edit Manually</p>
            <p className="text-sm text-muted-foreground">Select and modify spec values manually</p>
          </div>
        </CardContent>
      </Card>
    </div>
    <div className="flex justify-end">
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  </div>
);
